<!--订单成本毛利表-->
<template>
  <div class="orderCostGrossProfit">
    <el-row>
      <el-form :model="searchForm" ref="searchForm" :inline="true">
        <el-form-item label="客户：">
          <el-select size="medium" filterable v-model="searchForm.TC_ID" placeholder="请选择" clearable>
            <el-option v-for="item in companyLists" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目点：">
          <el-select size="medium" @change="queryDkList" filterable v-model="searchForm.PROJECT_ID" placeholder="请选择" clearable>
            <el-option v-for="item in projects" :key="item.value" :label="item.PROJECT_NAME" :value="item.PROJECT_ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="档口：">
          <el-select size="medium"filterable v-model="searchForm.DK_ID" placeholder="请选择档口" style="width: 100%" clearable>
            <el-option v-for="item in dkList" :key="item.ID" :label="item.NAME" :value="item.ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期范围：">
          <el-date-picker size="medium" v-model="searchForm.START_END" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" clearable>
          </el-date-picker>
        </el-form-item>
        <el-form-item label="出库日期：">
          <el-date-picker size="medium" v-model="searchForm.ENTRY_DATE" type="date" value-format="yyyy-MM-dd" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" clearable>
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="medium" type="primary" class="btn" @click="querySearch">筛选</el-button>
          <el-button size="medium" class="btn" @click="exportForm">导出</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" max-height="520" stripe border>
          <el-table-column label="序号" type="index" width="50px"></el-table-column>
          <el-table-column label="订单编号" prop="ORDER_CODE" min-width="200px"></el-table-column>
          <el-table-column label="送货日期" prop="SEND_DAY"></el-table-column>
          <el-table-column label="出库日期" prop="DELIVER_DAY"></el-table-column>
          <el-table-column label="客户" prop="TC_NAME"></el-table-column>
          <el-table-column label="项目点" prop="PROJECT_NAME"></el-table-column>
          <el-table-column label="档口" prop="DK_NAME"></el-table-column>
          <el-table-column label="收入" prop="TOTAL_ORDER_FEE"></el-table-column>
          <el-table-column label="成本" prop="DELIVER_TOTAL_FEE"></el-table-column>
          <el-table-column label="毛利" prop="PROFIT"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div class="pagination_box" style="text-align: right">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import http from '@/assets/common/http';
import date from '@/assets/common/date';

export default {
  data() {
    return {
      searchForm: {
        TC_ID: '',
        PROJECT_ID: '',
        DK_ID: '',
        START_END: [date(new Date(), '%F'), date(new Date(), '%F')],
        ENTRY_DATE: '',
      },
      companyLists: [],
      projects: [],
      dkList: [],
      totalCount: 0,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      currentPage: 1,
      tableData: [],
    };
  },
  created() {
    this.queryTcAndPro();
    this.queryData();
  },
  methods: {
    // 拉取客户列表和项目点列表
    queryTcAndPro() {
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 15,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        this.projects = result.length > 0 ? result[0].project : [];
        this.companyLists = result.length > 0 ? result[0].company : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 获取档口列表
    queryDkList() {
      this.searchForm.DK_ID = '';
      if (!this.searchForm.PROJECT_ID) {
        this.dkList = [];
        return false;
      }
      const params = {
        SERVICE_ID: '10007',
        OTYPE: 4,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.PROJECT_ID) {
        const PROJECT_ID_LIST = [];
        PROJECT_ID_LIST.push(this.searchForm.PROJECT_ID);
        params.PROJECTS_ID = PROJECT_ID_LIST;
      } else {
        this.dkList = [];
        return false;
      }
      http.post(params).then((result) => {
        this.dkList = result;
      }).catch((err) => {
        this.$message.show({
          text: err,
          type: 'error',
        });
      });
    },
    // 筛选
    querySearch() {
      if (!(this.searchForm.START_END != null && this.searchForm.START_END.length == 2 || this.searchForm.ENTRY_DATE)) {
        this.$message.show({ text: '请至少选择日期范围或退货日期或出库日期中的一项', type: 'warning' });
        return;
      }
      this.queryData();
    },
    // 导出
    exportForm() {
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 52,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      if (this.searchForm.PROJECT_ID) {
        params.PROJECT_ID = this.searchForm.PROJECT_ID;
      }
      if (this.searchForm.DK_ID) {
        params.DK_ID = this.searchForm.DK_ID;
      }
      if (this.searchForm.START_END != null && this.searchForm.START_END.length == 2) {
        params.START_DAY = this.searchForm.START_END[0];
        params.END_DAY = this.searchForm.START_END[1];
      }
      if (this.searchForm.ENTRY_DATE) {
        params.DELIVER_DAY = this.searchForm.ENTRY_DATE;
      }
      http.post(params)
        .then((result) => {
          window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 拉取数据
    queryData() {
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 51,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PAGEINDEX: this.currentPage - 1,
        PAGESIZE: this.pageSize,
      };
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      if (this.searchForm.PROJECT_ID) {
        params.PROJECT_ID = this.searchForm.PROJECT_ID;
      }
      if (this.searchForm.DK_ID) {
        params.DK_ID = this.searchForm.DK_ID;
      }
      if (this.searchForm.START_END) {
        params.START_DAY = this.searchForm.START_END[0];
        params.END_DAY = this.searchForm.START_END[1];
      }
      if (this.searchForm.ENTRY_DATE) {
        params.DELIVER_DAY = this.searchForm.ENTRY_DATE;
      }
      http.post(params).then((result) => {
        if (result.length > 0) {
          this.totalCount = result[0].TOTAL_COUNT;
          this.tableData = result[0].list;
        } else {
          this.totalCount = 0;
          this.tableData = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData();
    },
  },
};
</script>
<style scoped>
.el-form>>>.el-form-item {
  margin-right: 60px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/tableManage/orderCostGrossProfit.vue